<template>
  <n-modal :auto-focus="false" :show="showModal" :on-update:show="onShowUpdate" :closable="closable"
    :close-on-esc="closable"
  class="overflow-hidden">
    <slot />
  </n-modal>
</template>

<script setup lang="ts">
import { NModal } from "naive-ui";

defineProps({
  showModal: Boolean,
  closable: Boolean,
});

const emit = defineEmits(["hide"]);

function onShowUpdate(val: boolean) {
  if(!val) {
    emit("hide");
  }
}
</script>
